export default ({ request }) => ({
  ecomHxSkuListApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/save',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuDelApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/del',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuFullMemberApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/fullMember',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuApplyApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/apply',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuApprovedApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/approved',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuRejectApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/reject',
      method: 'POST',
      data,
    })
  },
  //  产品图片
  ecomHxSkuImageListApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/image/list',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuImageUploadApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuImageDelApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/image/del',
      method: 'POST',
      data,
    })
  },

  //生产厂家
  ecomHxSkuFtyListApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/fty/list',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuFtyDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/fty/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuFtySaveApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/fty/save',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuFtyDelApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/fty/del',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuFtyMatchNoResultReturnDefaultApi(params = {}) {
    return request({
      url: '/ecom/hx/sku/fty/matchNoResultReturnDefault',
      method: 'GET',
      params,
    })
  },
  ecomHxSkuListBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/listBySpuCode',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuDetailPrintViewApi(params = {}) {
    return request({
      url: '/ecom/hx/sku/print/detail',
      method: 'GET',
      params,
    })
  },
  ecomHxSkuFtyScmNcNoApi(params = {}) {
    return request({
      url: '/ecom/hx/sku/fty/scm/ncNo',
      method: 'GET',
      params,
    })
  },

  ecomHxSkuFtyPrintScmListApi(params = {}) {
    return request({
      url: '/ecom/hx/sku/fty/print/scm/list',
      method: 'GET',
      params,
    })
  },
  ecomHxSkuPlatformListApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/list',
      method: 'POST',
      data,
    })
  },
  ecomHxSkuCopyApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/copy/detail',
      method: 'POST',
      data,
    })
  },
})
